module.exports = __webpack_public_path__ + "static/media/gatsby.f422e499.png";